<div class="ect2-app">
  <router-outlet></router-outlet>
</div>
